import { Injectable, ɵConsole } from '@angular/core';
import { LocalService } from '@app/shared/services/local.service';
interface IPermissions {
  type: string;
  name: string;
}

interface IPermissonManager {
  setPermissions: Function;
  getPermissions: Function;
  hasNamePermission: Function;
}

@Injectable({
  providedIn: 'root',
})
export class PermissionsManagerService implements IPermissonManager {
  permission = this.secureStorage.getJsonValue('permissions')
  constructor(private secureStorage: LocalService) {

  }
  setPermissions(permissions: IPermissions[]) {
    this.secureStorage.setJsonValue('permissions', JSON.stringify(permissions));
  }

  getPermissions(): any {
    if (this.permission) {
      return JSON.parse(this.permission);
    } else {
      this.permission = this.secureStorage.getJsonValue('permissions')
      return JSON.parse(this.permission);
    }
  }

  hasNamePermission(permission: string): boolean {
    const permissions: IPermissions = this.getPermissions() as IPermissions;
    if (Array.isArray(permissions)) {
      return permissions.some(
        (permi: IPermissions) => permi.name == permission,
      );
    }

    return false;
  }

  hasNamePermissionAndType(permission: string, type: string): boolean {
    const permissions: IPermissions = this.getPermissions() as IPermissions;
    if (Array.isArray(permissions)) {
      return permissions.some(
        (permi: IPermissions) => permi.name == permission && permi.type == type,
      );
    }

    return false;
  }

  checkAllPermissons(permissionsToValidate: Array<string>) {
    const permissionsToCheckSize = permissionsToValidate.length;
    const permissions: IPermissions[] = this.getPermissions();

    let ruleChecked: Array<string> = [];

    permissionsToValidate.forEach(rule => {
      permissions.forEach(r => {
        if (r.name == rule) {
          ruleChecked.push(rule);
        }
      });
    });

    return ruleChecked.length == permissionsToCheckSize;
  }
}
